/**
 * Games Elena hosts (by voice, typing or buttons) and the state the apps render.
 * The rules run on the server; the apps only draw this state and send moves.
 */
export const gameIds = ['kaladont', 'moj_broj', 'skocko', 'asocijacije', 'ko_zna_zna'];
export const gameInfo = {
    kaladont: {
        name: 'Kaladont',
        hint: 'Reč počinje sa poslednja dva slova prethodne',
        rules: 'Kažeš imenicu koja počinje sa poslednja dva slova moje reči. Reč ne sme da se završava na „ka“, jer onda drugi kaže KALADONT i pobeđuje. Reči se ne ponavljaju.',
    },
    moj_broj: {
        name: 'Moj broj',
        hint: 'Šest brojeva, jedan traženi',
        rules: 'Od šest brojeva napravi traženi broj sa +, −, × i ÷. Svaki broj najviše jednom, deljenje mora da bude bez ostatka. Reci ili ukucaj račun, npr. „(75 + 25) × 3“.',
    },
    skocko: {
        name: 'Skočko',
        hint: 'Pogodi četiri znaka u šest pokušaja',
        rules: 'Zamislila sam 4 znaka od: skočko, tref, pik, herc, karo, zvezda. Crveno je pravi znak na pravom mestu, žuto pravi znak na pogrešnom. Imaš 6 pokušaja.',
    },
    asocijacije: {
        name: 'Asocijacije',
        hint: 'Četiri kolone, jedno konačno rešenje',
        rules: 'Otvaraj polja („otvori A1“), pogađaj rešenje kolone („A: more“) ili konačno rešenje („konačno: leto“). Neotvorena polja donose više poena.',
    },
    ko_zna_zna: {
        name: 'Ko zna zna',
        hint: 'Deset pitanja, brzi odgovori',
        rules: 'Deset pitanja. Tačan odgovor +10, netačan −5, „dalje“ preskače bez poena.',
    },
};
export const skockoSymbols = ['skocko', 'tref', 'pik', 'herc', 'karo', 'zvezda'];
export const skockoLabels = {
    skocko: 'Skočko',
    tref: 'Tref',
    pik: 'Pik',
    herc: 'Herc',
    karo: 'Karo',
    zvezda: 'Zvezda',
};
export const moods = [
    { id: 'nezna', label: 'Nežna', hint: 'Topla i konkretna, kao do sada' },
    { id: 'sarkasticna', label: 'Sarkastična', hint: 'Duhovita, malo bocka, nikad zla' },
    { id: 'motivator', label: 'Motivator', hint: 'Diže te iz kreveta i gura napred' },
    { id: 'baka', label: 'Baka', hint: 'Brižna srpska baka: jesi li jeo, sine?' },
    { id: 'narator', label: 'Narator', hint: 'Dokumentarac o tvom životu' },
    { id: 'komentator', label: 'Sportski komentator', hint: 'Sve je prenos uživo' },
];
//# sourceMappingURL=games.js.map